import React from 'react'
import GreenIcon from '../../../images/Green Icon.png'

const Step = (props) => {

    const newConnStyle = { minWidth: '9.7%', width: 'auto' }

    const mcrWithSiteMNTStyle = { minWidth: '7%', width: 'auto', maxWidth: '9.5%' }

    const mrcStyle = { minWidth: '19.75%', width: 'auto', maxWidth: '19.75%' }

    const mcrWithLabMNTStyle = { minWidth: '5%', width: 'auto', maxWidth: '7.6%' }

    const mcrWithOutMNTStyle = { minWidth: '10.9%', width: 'auto' }

    const duedateExtensionStyle = { minWidth: '49%', width: 'auto' }

    const installmentsStyle = { minWidth: '49%', width: 'auto' }

    const defaultStyle = { minWidth: '9.7%', width: 'auto' }

    const complaintsStyle = { minWidth: '19.75%', width: 'auto' }

    return (
        <div className={props.status === 1 ? 'step done' : 'step'}
            style={
                props.pageName === 'New Connection' ? newConnStyle :
                    props.pageName === 'Due Date Extension' ? duedateExtensionStyle :
                        props.pageName === 'Installments' ? installmentsStyle :
                            props.pageName === 'Meter Reading Correction' ? mrcStyle :
                                props.pageName === 'Meter Change Request With Site MNT' ? mcrWithSiteMNTStyle :
                                    props.pageName === 'Meter Change Request With Lab MNT' ? mcrWithLabMNTStyle :
                                        props.pageName === 'Meter Change Request Without MNT' ? mcrWithOutMNTStyle :
                                            props.pageName === 'Power Complaints' ? complaintsStyle
                                                : defaultStyle}>
            <div className='span'>
                <div className='span-content'>
                    <div className='icon-button'>
                        {props.status === 0 ? props.number : <img src={GreenIcon} alt="Arear paid bill" width="17" />}
                    </div>
                </div>
                <div className='step-title'>
                    <span style={{ display: 'block' }}>
                        {props.title1}
                    </span>
                    <span style={{ display: 'block' }}>
                        {props.title2}
                    </span>
                </div>
            </div>
        </div >
    )
}

export default Step